<template>
  <div>
    <b-row>
      <b-col sm="4">
        <b-input type="text" placeholder="Type to search" v-model.trim="filter"></b-input>
      </b-col>
    </b-row><br/>
    <b-row>
      <b-col sm="12" md="12">
        <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="getRecords" :fields="fields" :per-page="perPage" :current-page="currentPage" :filter="filter">
          <template v-slot:cell(sn)="data">
            {{ data.index + 1 + ((currentPage - 1) * perPage) }}
          </template>
          <template v-slot:cell(action)="data">
            <b-btn class="btn-sm" variant="success" @click="checkDupliate(data.item)">Check Duplicate</b-btn>
          </template>
          <template v-slot:row-details="data">
            <duplicate-account-detail :details="data.item.details"/>
          </template>
          <template v-slot:cell(Turnover)="data">
            {{ format(data.item.Turnover, '0,0.00') }}
          </template>
          <template v-slot:cell(NetWin)="data">
            {{ format(data.item.NetWin, '0,0.00') }}
          </template>
          <template v-slot:cell(HouseEdge)="data">
            {{ format(data.item.HouseEdge, '0.00%') }}
          </template>
        </b-table>
        <nav>
          <b-pagination :total-rows="getRowCount(getRecords)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" />
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import numeral from 'numeral'
import { Events } from '../../../../events.js'
import VueNotifications from 'vue-notifications'
import DuplicateAccountDetail from './DuplicateAccountDetail'

export default {
  name: 'high-abnormal-bet-detail-table',
  props: {
    details: {
      type: Array,
      default: []
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: true
    },
    small: {
      type: Boolean,
      default: true
    },
    fixed: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      fields: [
        {key: 'sn', label: 'SN', thStyle: { width: '50px' }},
        {key: 'action', label: 'Action', thStyle: { width: '150px' }},
        {key: 'Username', label: 'Username'},
        {key: 'Turnover', label: 'Turnover', sortable: true},
        {key: 'NetWin', label: 'NetWin', sortable: true},
        {key: 'HouseEdge', label: 'House Edge (%)'}
      ],
      filter: '',
      currentPage: 1,
      perPage: 30
    }
  },
  components: {
    DuplicateAccountDetail
  },
  computed: {
    getRecords: function () {
      return this.details
    }
  },
  methods: {
    format (num, fmt) {
      return numeral(num).format(fmt)
    },
    getRowCount (items) {
      return items.length
    },
    async checkDupliate (item) {
      console.log(item)
      if (item._showDetails) {
        item._showDetails = false
      } else {
        if (item.details) {
          item._showDetails = true
        } else {
          try {
            Events.$emit('loader')
            let { data } = await this.$http.post(this.API_ENDPOINT + '/report/member/risk/duplicateMember', {
              memberId: item.MemberId
            }, { headers: { 'Content-Type': 'application/json' } })
            item.details = data
            this.$set(item, '_showDetails', true)
          } catch (err) {
            console.log('this is an error ', err)
            Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
            item._showDetails = false
          } finally {
            Events.$emit('loader')
          }
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/report/risk/game/BetDetail.vue